<form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
  <div class="modal-body">
    <div class="row">
      <div class="col-12 col-md-4 mb-3">
        <label for="currentPassword" class="form-label">Current Password</label>
        <div class="password-field">
          <input
            [type]="showCurrentPassword ? 'text' : 'password'"
            id="currentPassword"
            class="form-control"
            formControlName="currentPassword"
            [class.is-invalid]="
              changePasswordForm.get('currentPassword')?.invalid &&
              (changePasswordForm.get('currentPassword')?.dirty || changePasswordForm.get('currentPassword')?.touched)
            "
            placeholder="Enter current password" />
          <button
            type="button"
            class="password-toggle-btn"
            [attr.aria-label]="showCurrentPassword ? 'Hide current password' : 'Show current password'"
            [attr.aria-pressed]="showCurrentPassword"
            (click)="showCurrentPassword = !showCurrentPassword">
            <i class="bi" [ngClass]="showCurrentPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
          </button>
        </div>
        <div
          *ngIf="
            changePasswordForm.get('currentPassword')?.errors?.['required'] &&
            (changePasswordForm.get('currentPassword')?.dirty || changePasswordForm.get('currentPassword')?.touched)
          "
          class="text-danger">
          Current Password is required
        </div>
      </div>

      <div class="col-12 col-md-4 mb-3">
        <label for="newPassword" class="form-label">New Password</label>
        <div class="password-field">
          <input
            [type]="showNewPassword ? 'text' : 'password'"
            id="newPassword"
            class="form-control"
            formControlName="newPassword"
            [class.is-invalid]="
              changePasswordForm.get('newPassword')?.invalid &&
              (changePasswordForm.get('newPassword')?.dirty || changePasswordForm.get('newPassword')?.touched)
            "
            placeholder="Enter new password" />
          <button
            type="button"
            class="password-toggle-btn"
            [attr.aria-label]="showNewPassword ? 'Hide new password' : 'Show new password'"
            [attr.aria-pressed]="showNewPassword"
            (click)="showNewPassword = !showNewPassword">
            <i class="bi" [ngClass]="showNewPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
          </button>
        </div>
        <div
          *ngIf="
            changePasswordForm.get('newPassword')?.errors?.['required'] &&
            (changePasswordForm.get('newPassword')?.dirty || changePasswordForm.get('newPassword')?.touched)
          "
          class="text-danger">
          New Password is required
        </div>
      </div>

      <div class="col-12 col-md-4 mb-3">
        <label for="confirmPassword" class="form-label">Confirm New Password</label>
        <div class="password-field">
          <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            id="confirmPassword"
            class="form-control"
            formControlName="confirmPassword"
            placeholder="Confirm new password"
            [class.is-invalid]="
              (changePasswordForm.get('confirmPassword')?.invalid || changePasswordForm.errors?.['passwordMismatch']) &&
              (changePasswordForm.get('confirmPassword')?.dirty || changePasswordForm.get('confirmPassword')?.touched)
            " />
          <button
            type="button"
            class="password-toggle-btn"
            [attr.aria-label]="showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'"
            [attr.aria-pressed]="showConfirmPassword"
            (click)="showConfirmPassword = !showConfirmPassword">
            <i class="bi" [ngClass]="showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
          </button>
        </div>
        <div
          *ngIf="
            changePasswordForm.get('confirmPassword')?.errors?.['required'] &&
            (changePasswordForm.get('confirmPassword')?.dirty || changePasswordForm.get('confirmPassword')?.touched)
          "
          class="text-danger">
          Confirm Password is required
        </div>
        <div
          *ngIf="
            changePasswordForm.errors?.['passwordMismatch'] &&
            (changePasswordForm.get('confirmPassword')?.dirty || changePasswordForm.get('confirmPassword')?.touched)
          "
          class="text-danger">
          New Password and Confirm Password do not match
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" [disabled]="changePasswordForm.invalid">
      <ng-container *ngIf="isResettingPassword; else saveIcon">
        <app-loading-spinner [inline]="true" class="me-1"></app-loading-spinner>
      </ng-container>

      <ng-template #saveIcon>
        <i class="bi bi-check-circle me-1"></i>
      </ng-template>
      <span>Save</span>
    </button>
    <button type="button" class="btn btn-secondary" (click)="onCancel()">
      <i class="bi bi-x-circle me-1"></i>
      Cancel
    </button>
  </div>
</form>
